<template>
  <div class="error">
    <h1>Error Page</h1>
    <pre>{{ error }}</pre>
    <button @click="handleError()">Clear error</button>
  </div>
</template>

<script setup lang="ts">
const error = useError();

function handleError() {
  clearError({ redirect: '/' });
}
</script>
